import colors from '../../theme/colors'
import { HeaderImport } from './Import'
const { RoutesMap, useNavigate, useDispatch, Dropdown, KeyRound, Languages, ListCollapse, Power, UserPen, img_nf, ChangePassword, SessionManager, toggleChangePasswordModal, useTranslation } = HeaderImport

export default function Header(props) {

    const { collapsed, setCollapsed, drawerOpen, setDrawerOpen, isMobileOrTablet } = props
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    let cookieUser = SessionManager.getCookie("user");
    let user_details = cookieUser ? JSON.parse(cookieUser) : null;
    // console.log(user_details)

    const lang_option = {
        items: [
            { key: 'en', label: 'English' },
        ],
        selectable: true,
        defaultSelectedKeys: [i18n?.language],
        onClick: ({ key }) => {
            i18n.changeLanguage(key)
        },
    };

    const settings_option = [
        {
            key: '1',
            label: 'Profile',
            icon: <UserPen size={16} />,
            onClick: () => navigate('/profile')
        },
        {
            key: '2',
            label: 'Change Password',
            icon: <KeyRound size={16} />,
            onClick: () => changePasswordModal()
        },
        {
            type: 'divider',
        },
        {
            key: '3',
            label: 'Log Out',
            icon: <Power size={16} />,
            onClick: () => logout()
        },
    ];

    const changePasswordModal = () => dispatch(toggleChangePasswordModal())

    const logout = () => {
        SessionManager.removeCookie("user_token");
        SessionManager.removeCookie("user");
        navigate(RoutesMap.LOGIN.path)
    }

    return (
        <>
            <nav className={`navbar fixed-top ${isMobileOrTablet ? 'navbar_mobile_view' : collapsed ? "navbar_body_collapsed" : "navbar_body_notcollapsed"}`} >
                <div className="container-fluid">
                    <span className="navbar-brand" onClick={() => isMobileOrTablet ? setDrawerOpen(!drawerOpen) : setCollapsed(!collapsed)} style={{ cursor: 'pointer' }}>
                        <ListCollapse style={{ color: colors.secondary }} />
                    </span>

                    <div className='d-flex align-items-center'>

                        <Dropdown
                            menu={lang_option}
                            placement="bottom"
                        >
                            <Languages size={20} style={{ cursor: 'pointer' }} />
                        </Dropdown>

                        <span className='ms-2 me-2'>|</span>

                        <span className='fw-medium text-capitalize'>Hello, {user_details?.user_first_name || ''}!</span>

                        <span className='ms-2 me-2'>|</span>

                        <span className='fw-medium text-capitalize' style={{ color: colors.secondary, fontSize: '14px' }}>({user_details?.roleInfo?.role_name || ''})</span>

                        <span className='ms-2 me-2'>|</span>

                        <Dropdown
                            menu={{ items: settings_option }}
                            placement="bottom"
                        >
                            <img
                                src={user_details?.user_profile && process.env.REACT_APP_BASE_URL + user_details?.user_profile || img_nf}
                                alt="admin"
                                className='img-fluid header_profile_img'
                                style={{ cursor: 'pointer' }}
                                onError={(e) => { e.target.onerror = null; e.target.src = img_nf }}
                            />
                        </Dropdown>
                    </div>
                </div>
            </nav>

            <ChangePassword />
        </>
    )
}
